Object.defineProperty(exports,"__esModule",{value:true});exports.Flyout=exports.Voronoi=exports.Slice=exports.Point=exports.Line=exports.ErrorBar=exports.Curve=exports.ClipPath=exports.Candle=exports.Bar=exports.Area=undefined;var _area=require("./area");var _area2=_interopRequireDefault(_area);
var _bar=require("./bar");var _bar2=_interopRequireDefault(_bar);
var _candle=require("./candle");var _candle2=_interopRequireDefault(_candle);
var _clipPath=require("./clip-path");var _clipPath2=_interopRequireDefault(_clipPath);
var _curve=require("./curve");var _curve2=_interopRequireDefault(_curve);
var _errorBar=require("./error-bar");var _errorBar2=_interopRequireDefault(_errorBar);
var _line=require("./line");var _line2=_interopRequireDefault(_line);
var _point=require("./point");var _point2=_interopRequireDefault(_point);
var _slice=require("./slice");var _slice2=_interopRequireDefault(_slice);
var _voronoi=require("./voronoi");var _voronoi2=_interopRequireDefault(_voronoi);
var _flyout=require("./flyout");var _flyout2=_interopRequireDefault(_flyout);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.



Area=_area2.default;exports.Bar=_bar2.default;exports.Candle=_candle2.default;exports.ClipPath=_clipPath2.default;exports.Curve=_curve2.default;exports.ErrorBar=_errorBar2.default;exports.Line=_line2.default;exports.Point=_point2.default;exports.Slice=_slice2.default;exports.Voronoi=_voronoi2.default;exports.Flyout=_flyout2.default;


//////////////////
// WEBPACK FOOTER
// ./~/victory-core/lib/victory-primitives/index.js
// module id = 271
// module chunks = 0